class SegmentError extends Error {
    constructor(message) {
        super(message);
        this.name = "SegmentError";
    }
}

const sendError = (msg) => {
    console.warn(msg);
    if (process.env.NODE_ENV === "production") {
        if (window.Sentry) {
            window.Sentry.captureException(new SegmentError(msg));
        }
    }
};

const fakeAnalytics = {
    track: () => {},
    page: () => {},
    ready: () => {},
};

const getWindowAnalytics = () => {
    // This method should not run outside the browser runtime, this is just
    // sanity protection against SSR builds
    if (typeof window !== "undefined") {
        return window.analytics;
    }

    return fakeAnalytics;
};

const getProject = () => {
    const projectTypes = ["bifrost", "blog", "docs"];

    if (typeof window !== "undefined") {
        const project = window.MEMSQL_PROJECT;
        if (!projectTypes.includes(project)) {
            sendError(`Unexpected project - ${project}`);
        }
        return project;
    }
};

export const track = ({ action, category, ...properties }) => {
    const analytics = getWindowAnalytics();
    const project = getProject();

    const _action = `${project}-${action}`;
    const _properties = {
        category: `${project}-${category}`,
        ...properties,
    };

    analytics.track(_action, _properties);
};

export const page = ({ properties = {} }) => {
    const analytics = getWindowAnalytics();

    analytics.page(properties);
};

export const ready = (callback) => {
    const analytics = getWindowAnalytics();

    analytics.ready(callback);
};



// WEBPACK FOOTER //
// ./themes/docs/static/js/util/segment.js